import { faFileAlt } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { GLOBALS } from "../../Models/Globals";
import { NoRecordsMessage } from "../NoRecordsMessage/NoRecordsMessage";
import { HeaderTableCell } from "../Styled/HeaderTableCell";
import { ITableDocsDetailProps } from "./ITableDocsDetailProps";




export const TableDocsDetail = ({

    Title,
    Records

}: ITableDocsDetailProps) => {



    return (
        <Grid item xs={12} sx={{ paddingTop: "1rem" }}>
            {
                Records.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableRow>
                                    <HeaderTableCell align="center">{Title}</HeaderTableCell>
                                </TableRow>
                                <TableRow>
                                    <HeaderTableCell align="center">{t('label-file-name')}</HeaderTableCell>
                                    <HeaderTableCell align="center">{t('label-publish-date')}</HeaderTableCell>
                                    <HeaderTableCell align="center">{t('label-last-update')}</HeaderTableCell>
                                    <HeaderTableCell align="center">{t('label-file-size')}</HeaderTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Records.map((doc, index) => (
                                        <TableRow>
                                            <TableCell align="center">
                                                <Button href={doc.url} download target="_blank">
                                                    <Typography variant="body1">
                                                        <FontAwesomeIcon icon={faFileAlt} /> {doc.nombre}
                                                    </Typography>
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                {moment(doc.fecha_publicacion).format(GLOBALS.DATE_FORMAT)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {
                                                    doc.fecha_actualizacion == null ? (
                                                        <>
                                                            -
                                                        </>
                                                    ) : (
                                                        <>
                                                            {moment(doc.fecha_actualizacion).format(GLOBALS.DATE_FORMAT)}
                                                        </>
                                                    )
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                {doc.size}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <>
                    </>
                )
            }
        </Grid>
    );

}